import AppBar from "@mui/material/AppBar";
import { Box, Button, Container, Toolbar } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Logo from "../common/Logo";
import { NavLink } from "react-router";
import routes from "../../routes";
import { useIsProspectListPage } from "../../hooks/useIsProspectListPage";
import { useAuth0 } from "@auth0/auth0-react";

const Header = () => {
  const { logout } = useAuth0();
  const isMobile = useMediaQuery("(max-width:930px)");
  const isProspectsPage = useIsProspectListPage();
  const links = [
    { label: "Clients", path: routes.clients.base.pattern },
    { label: "Users", path: routes.users.base.pattern },
    { label: "Projects", path: routes.solutions.base.pattern },
    { label: "Biodiversity", path: routes.biodiversity.base.pattern },
    { label: "Reporting", path: routes.reporting.base.pattern },
    { label: "Prospects", path: routes.prospects.base.pattern },
    {
      label: "Preassess project",
      path: "https://earthlytech.retool.com/apps/a9db749c-775a-11f0-b290-df3eef8c684f/Preassessment/PDDUploadPage",
      openInNewTab: true,
    },
  ];

  const style = {
    headerContainer: {
      display: "block",
      backgroundColor: "#f7f7f7",
      ...(isProspectsPage && {
        left: 0,
        width: "100vw",
      }),
    },
    menuContainer: {
      display: "flex",
      flexGrow: 1,
      flexWrap: "wrap",
      justifyContent: isMobile ? "center" : "start",
      paddingLeft: isMobile ? 0 : "12%",
    },
    navLink: {
      textDecoration: "none",
      color: "inherit",
    },
    navLinkActive: {
      textDecoration: "underline",
      textUnderlineOffset: "6px",
      fontWeight: "bold",
    },
    menuButton: {
      textTransform: "none",
      paddingRight: isMobile ? "24px" : "35px",
      display: "block",
      fontSize: "16px",
      "&:hover": {
        backgroundColor: "transparent", // Remove hover background
      },
    },
  } as const;

  return (
    <AppBar sx={style.headerContainer} data-testid="header" position="sticky">
      <Container maxWidth={false}>
        <Toolbar disableGutters>
          <Logo />
          <Box sx={style.menuContainer}>
            {links.map((link) => (
              <NavLink
                to={link.path}
                key={link.label}
                style={({ isActive }) =>
                  isActive ? style.navLinkActive : style.navLink
                }
                target={link?.openInNewTab ? "_blank" : "_self"}
              >
                <Button sx={style.menuButton}>{link.label}</Button>
              </NavLink>
            ))}
          </Box>
          <Box>
            <Button
              sx={style.menuButton}
              onClick={() =>
                logout({ logoutParams: { returnTo: window.location.origin } })
              }
            >
              Log Out
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default Header;
